/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_Build_DescInputs */

const en_mk_nav_build_desc = /** @type {(inputs: Mk_Nav_Build_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose automatic, guided, or local building.`)
};

const id_mk_nav_build_desc = /** @type {(inputs: Mk_Nav_Build_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih otomatis, didampingi, atau mandiri.`)
};

/**
* | output |
* | --- |
* | "Choose automatic, guided, or local building." |
*
* @param {Mk_Nav_Build_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_build_desc = /** @type {((inputs?: Mk_Nav_Build_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_Build_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_build_desc(inputs)
	return en_mk_nav_build_desc(inputs)
});